import React from 'react';
import { Grid, TextField, Button, Typography, Box, Divider, Paper, Chip } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { SectionHeader } from '../AddPatientStyles';

const StepDocumentsPortal = ({ 
  formData, 
  handleChange, 
  documentFiles, 
  handleAddDocuments, 
  handleRemoveDocument 
}) => {
  return (
    <Box>
      <SectionHeader title="Pièces justificatives" description="Documents médicaux et administratifs liés au dossier" />
      <Button type="button" variant="outlined" component="label" startIcon={<CloudUploadIcon />} sx={{ borderStyle: 'dashed', py: 2, width: '100%', color: '#4318FF', borderColor: '#4318FF' }}>
        Ajouter des documents (PDF, images) <input type="file" hidden multiple onChange={handleAddDocuments} />
      </Button>
      {documentFiles.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
          {documentFiles.map((file, index) => (
            <Chip key={`${file.name}-${index}`} icon={<InsertDriveFileOutlinedIcon />} label={file.name} onDelete={() => handleRemoveDocument(index)} sx={{ bgcolor: '#F4F7FE', color: '#2B3674', fontWeight: 500 }} />
          ))}
        </Box>
      )}
      
      <Divider sx={{ my: 3 }} />

      {/* Vérification basée sur la confirmation du client existant */}
      {formData.isExistingClient ? (
        <Box>
          <SectionHeader title="Compte client / Portail patient" description="Ce dossier est rattaché à un client existant validé." />
          <Paper elevation={0} sx={{ p: 2.5, backgroundColor: '#E6FFFA', border: '1px solid #B2F5EA', borderRadius: '10px', display: 'flex', alignItems: 'center', gap: 2 }}>
            <CheckCircleIcon sx={{ color: '#319795', fontSize: 32 }} />
            <Box>
              <Typography sx={{ fontSize: '0.9rem', color: '#234E52', fontWeight: 700 }}>
                Client déjà attaché : {formData.prenom_patient} {formData.nom_patient}
              </Typography>
              <Typography sx={{ fontSize: '0.85rem', color: '#319795', mt: 0.5 }}>
                Email : {formData.email_patient} | Téléphone : {formData.telephone_patient || 'Non renseigné'}
              </Typography>
              <Typography sx={{ fontSize: '0.75rem', color: '#2b6cb0', mt: 0.5 }}>
                Aucun nouveau compte ne sera créé ; le dossier sera directement lié à son profil existant.
              </Typography>
            </Box>
          </Paper>
        </Box>
      ) : (
        <Box>
          <SectionHeader title="Création du compte client / Portail patient" description="Ces informations seront utilisées pour créer un nouveau compte client associé au patient." />
          <Grid container spacing={2.5}>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Email du client" name="email_patient" type="email" value={formData.email_patient} onChange={handleChange} /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Mot de passe" name="password_client" type="password" value={formData.password_client} onChange={handleChange} placeholder="Défaut : password123!" /></Grid>
            <Grid item xs={12} sm={4}><TextField fullWidth label="Adresse client" name="addresse_client" value={formData.addresse_client} onChange={handleChange} /></Grid>
            <Grid item xs={12} sm={4}><TextField fullWidth label="Ville client" name="ville_client" value={formData.ville_client} onChange={handleChange} /></Grid>
            <Grid item xs={12} sm={4}><TextField fullWidth label="Code postal" name="cp_client" value={formData.cp_client} onChange={handleChange} /></Grid>
          </Grid>
        </Box>
      )}

      <Paper elevation={0} sx={{ mt: 3, p: 2, backgroundColor: '#F4F7FE', border: '1px solid #E0E5F2', borderRadius: '10px' }}>
        <Typography sx={{ fontSize: '0.85rem', color: '#2B3674', fontWeight: 600 }}>Enregistrement du dossier</Typography>
        <Typography sx={{ fontSize: '0.8rem', color: '#A3AED0', mt: .5 }}>En cliquant sur « Enregistrer le dossier complet », le profil et la fiche médicale seront rattachés au compte client.</Typography>
      </Paper>
    </Box>
  );
};

export default StepDocumentsPortal;